import { Button, Text } from "@wojo/ui";
import dayjs from "dayjs";
import { FiDownload, FiExternalLink } from "react-icons/fi";
import styles from "./EntryRequirementsInclusionDetail.module.scss";
import { SherpaInclusion } from "./SherpaInclusion";

export type EntryRequirementsInclusionDetailProps = {
    inclusion: SherpaInclusion;
};

export const EntryRequirementsInclusionDetail: React.FC<
    EntryRequirementsInclusionDetailProps
> = ({ inclusion }) => {
    const lastUpdatedAt =
        inclusion.attributes.lastUpdatedAt &&
        dayjs(inclusion.attributes.lastUpdatedAt).format("MM/DD/YYYY h:mm a");

    return (
        <div>
            {!!inclusion.attributes.title && (
                <Text.Body emphasis="2">{inclusion.attributes.title}</Text.Body>
            )}
            {!!lastUpdatedAt && (
                <Text.Body>Last updated: {lastUpdatedAt}</Text.Body>
            )}
            {!!inclusion.attributes.documentLinks.length && (
                <div className={styles.section}>
                    {inclusion.attributes.documentLinks.map((link, index) => (
                        <Button
                            adornLeft={
                                link.type === "DOWNLOAD" ? (
                                    <FiDownload />
                                ) : (
                                    <FiExternalLink />
                                )
                            }
                            href={link.url}
                            key={index}
                            rel="noopener"
                            tag="a"
                            target="_blank"
                            variant="quiet"
                        >
                            {link.title || "Download"}
                        </Button>
                    ))}
                </div>
            )}
            {!!inclusion.attributes.description && (
                <Text.Body className={styles.section}>
                    {inclusion.attributes.description}
                </Text.Body>
            )}
            {!!inclusion.attributes.more?.length &&
                inclusion.attributes.more.map((more, index) => (
                    <Text.Body className={styles.section} key={index}>
                        {more}
                    </Text.Body>
                ))}
            {!!inclusion.attributes.source && (
                <div className={styles.section}>
                    <Text.Body emphasis="2">Source</Text.Body>
                    <Button
                        adornLeft={<FiExternalLink />}
                        className={styles.source}
                        href={inclusion.attributes.source.url}
                        rel="noopener"
                        tag="a"
                        target="_blank"
                        variant="quiet"
                    >
                        {inclusion.attributes.source.title || "View source"}
                    </Button>
                </div>
            )}
        </div>
    );
};
